<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    <v-card class="elevation-10" dense :disabled="$store.getters.dialogLoader">
      <v-card-title class="justify-start primary">
        Planos de Assinatura
        <v-spacer></v-spacer>
        <v-text-field
            v-model="filter"
            append-icon="mdi-magnify"
            label="Filtrar"
            maxlength="10" 
            clearable
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
      

      <v-card-text class="pt-5">
          <v-data-table
            :headers="headers"
            :items="planos"
            :items-per-page="10"
            class="elevation-0"
            :search="filter"
          >
          <template v-slot:item.enabled="{item}">
            <span v-if="item.enabled">Ativo</span>
            <span v-if="!item.enabled">Inativo</span>
          </template>
          <template v-slot:item.profile="{item}">
            <v-btn large icon color="primary" @click="loadProfile(item)" :disabled="item.profile == null">
              <v-icon>mdi-card-account-details</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.edit="{item}">
            <v-btn large icon color="primary" @click="selectedPlano = item; showPlanoModal = true;" :disabled="!item.enabled">
              <v-icon>mdi-file-document-edit-outline</v-icon>
            </v-btn>
          </template>  
          <template v-slot:item.delete="{item}">
            <v-btn large icon color="primary" @click="selectedPlano = item; changeStatus();">
              <v-icon v-if="item.enabled">mdi-trash-can</v-icon>
              <v-icon v-if="!item.enabled" color="grey lighten-2">mdi-trash-can</v-icon>
            </v-btn>
          </template>  
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="selectedPlano = {}; showPlanoModal = true;" class="">
          ADICIONAR NOVO
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>


    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Carregando...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <plano-modal :item="selectedPlano" :showDialog="showPlanoModal" @close-dialog="closeDialog" />

  </v-container>
</template>

<script>

import HOST from '../ws'
import PlanoModal from '../components/PlanoModal'
import SnackBar from '../snackbar'

export default {

  components : {
    PlanoModal,
  },

  props: {
    source: String
  },
  data: () => ({

    dialogLoader : false,

    myHost : HOST.HOST,


    filter : '',

    plano : null,

    //dialogs:
    dialogEditPlano : false,
    dialogDisable : false,
    dialogProfile : false,

    showPlanoModal : false,

    //tabelas dos usuarios:
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Tipo',
        align: 'start',
        sortable: true,
        value: 'planType',
      },
      {
        text: 'Preço',
        align: 'center',
        sortable: false,
        value: 'formattedPrice',
      },
      {
        text: 'Data de Criação',
        align: 'center',
        sortable: true,
        value: 'dtCreated',
      },
      {
        text: 'Status',
        align: 'center',
        sortable: true,
        value: 'enabled',
      },
      
      {
        text: 'Editar',
        align: 'center',
        sortable: false,
        value: 'edit',
      },
      {
        text: 'Ativar/Desativar',
        align: 'center',
        sortable: false,
        value: 'delete',
      },
    ],

    //usuarios:
    planos : [],

    //usuario selecionado:
    selectedPlano : null,

    
  }),
  mounted() {
    
    this.selectedPlano = null;
    this.reloadPlanList();
  },
  methods : {

    closeDialog(){
      //this.$emit('close-dialog', false);
      this.showPlanoModal = false;
      this.selectedPlano = null;
      this.reloadPlanList();
    },

    reloadPlanList(){

      this.$store.commit("setDialogLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/plano/all', {}, config)
      .then(response => {
        this.planos = response.data;
        //console.log(JSON.stringify(this.planos));
        this.$store.commit("setDialogLoader", false);
      })
      .catch((error) => {
         console.log(error.message);
         this.$store.commit("setDialogLoader", false);
         this.$store.commit('logout');
         this.$router.push("login");
      });
    },

    saveItem() {

      this.$store.commit("setDialogLoader", true);
      
      this.axios({
        method: "post",
        url: this.myHost + "/plano/save",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        data: JSON.stringify(this.selectedPlano)
      }).then(response => {
        console.log("salvando item: " + response.status);
        this.$store.commit("setDialogLoader", false);
        this.closeDialog();
        SnackBar.snackText = "Item salvo com sucesso";
        SnackBar.showSnack = true;
      });
    },
    
    changeStatus(){
      this.selectedPlano.enabled = !this.selectedPlano.enabled;
      this.saveItem();
    }
    
  }
};
</script>
